export default {
    GET_OBJECTS_FAILED: "Не удалось получить информацию о объекта",
    GET_METHODS_FAILED: "Не удалось получить информацию о методах"
};
